<template>
  <div class="card-gerenciamento-condicoes-pagamento">      
      <g-card
      :expansivel="true" 
      :comecaFechado="false"
      >
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Condições de Pagamento </div>
          <div class="header-icons">
            <g-button
            class="trash-box"
            tipo="cinza"
            altura="35px"
            largura="45px"
            icone="icone_lixo.svg"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            v-tooltip="'Limpar filtro'"
            @click="limpar"
            />
            <g-button
            class="buscar-button-header-filtro"
            largura="150px"
            icone="icone_lupa.svg"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="15px"
            altura="35px"
            gap="10px"
            :sombreado="false"
            @click="GetCondicoesPagamentoByFiltro()"
            >
                BUSCAR
            </g-button>
          </div>
        </div>
      </template>
      <g-form>
        <div class="formadepagamentoPai">
          <div class="titulo-conteudo-filtros">Forma de pagamento</div>
          <div class="input-checkbox-filtro">
              <PInputText
              class="input-formadepagamento"
              v-model="condViewModel.FormaDePagamento"
              placeholder="Insira a forma de pagamento"
              />
              <PDropDown
                optionLabel="opcoes"
                optionValue="value"
                :options="AtivoArray"
                v-model="condViewModel.OpcaoAtivo"
                class="checkbox-ativo"
                :binary="true"
                >
                </PDropDown>
          </div>
        </div>
      </g-form>
    </g-card>

    <g-card>
      <div class="conteudo-card-gerenciamento-condicoes-pagamento">
              <div> 
                <g-data-table         
                Titulo="" 
                altura="auto"
                :valores = "CondicoesPagArray"
                :colunas="Colunas"
                :Filtros="Filtro"
                :Paginacao="true"
                :NumeroLinhas="50"
                :Editavel="true"
                TextEditar="Alterar atividade da condição de pagamento"
                v-on:editar="abrirPopupAtivo"
                >                              
                </g-data-table>
              </div>
          </div>
    </g-card>
  </div>

  <div class="popup-quantidade-tipo-pedido">
    <PDialog id="popup-quantidade-tipo-pedido" 
    :showHeader="false" 
    :closable="false" 
    :modal="true"
    v-model:visible="popup" 
    >
    <div class="conteudo-popup-atividade-condPagamento">
        <div class="titulo"> Deseja alterar essa condição de pagamento para: </div>              
        <div class="botoes-atividade">
          <div class="botao-ativo">
            <PRadioButton :binary="true" :value="true" v-model="Atividade"></PRadioButton>
            <div class="conteudo"> Ativo </div>
          </div>
          <div class="botao-inativo">
            <PRadioButton :binary="true" :value="false" v-model="Atividade"></PRadioButton>
            <div class="conteudo"> Inativo </div>
          </div>
        </div>
    </div>

    <div class="botoes-popup-atividade-condPagamento">
      <g-button
      tipo="cinza"
      class="botao-continuar"
      altura="35px"
      largura="180px"
      textoFontWeight="500"
      @click="fecharPopup"
      >
      VOLTAR            
    </g-button>
    <g-button
      tipo="amarelo"
      class="botao-voltar"
      altura="35px"
      largura="180px"
      textoFontWeight="500"
      @click="inativaFormaPagamento"
      >
        SALVAR
      </g-button>
    </div>
    </PDialog>
  </div>
</template>

<script>
import GerenciamentoCondicoesPagamento from './GerenciamentoCondicoesPagamento.js' 
export default GerenciamentoCondicoesPagamento
</script>

<style scoped>
.formadepagamentoPai {
  padding-left: 2%;
  width: 40%;
}
.input-checkbox-filtro{
  display: flex;
  gap: 5%
}
.conteudo-popup-atividade-condPagamento {
  display: flex;
  flex-direction: column;
  row-gap: 30px;
  align-items: center;
  margin: 30px auto 40px
}

.titulo {
  color: #4f2c19;
  font-family: "MontSerrat";
  font-weight: bold;
  font-size: 18px;
}

.conteudo {
  color: #747474;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: 500;
  font-size: 17px;
}

.botoes-atividade {
  display: flex;
  column-gap: 40px;
}

.botao-ativo, .botao-inativo {
  display: flex;
  column-gap: 5px;
}

.botoes-popup-atividade-condPagamento {
  display: flex;
  column-gap: 10px;
  justify-content: center;
}

@media (min-width:801px) {
.conteudo-card-gerenciamento-condicoes-pagamento {
  padding: 25px 25px;
}
} 

</style>
